"use client";
import { n as e } from "./neonSlam-Dq4On35E.js";
import { n as t } from "./neonPack-Cp_0eWRu.js";
import { t as n } from "./retailBox-DeCZBErW.js";
//#region src/allOpeners.ts
function r() {
	e(), t(), n();
}
//#endregion
export { r as registerAllOpeners };

//# sourceMappingURL=openers.js.map